import { render, staticRenderFns } from "./bgModal.vue?vue&type=template&id=2f64e357&"
import script from "./bgModal.vue?vue&type=script&lang=js&"
export * from "./bgModal.vue?vue&type=script&lang=js&"
import style0 from "./bgModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports